<card-container
  #cardContainer (contextmenu)="openMenu($event)"
  class="card-container {{ FirstCommentTourClasses.folderCard }}"
  [ngClass]="{ 'viewed': !unviewedState(folder) }"
  (click)="goToFolder.emit(folder)"
  (keyup.enter)="goToFolder.emit(folder)"
  data-cy="folder-row-or-card"
  tabindex="0"
  role="link"
  [attr.aria-label]="getAriaLabel(folder)"
  [matTooltip]="folder.name"
  [matTooltipDisabled]="!folderNameTruncated">
  <div main class="content">
    <dot-indicator
      [folder]="folder"
      [size]="12"
      [hasBorder]="true">
    </dot-indicator>
    @if (shouldShowFreeTrialBadge()) {
      <badge
        class="free-trial-badge"
        [badgeColor]="BadgeColors.SUCCESS"
        [badgeLabel]="'folder-free-trial-badge-label' | translate">
      </badge>
    }
    <div class="folder-icon">
      <i class="ficon-folder-outline"></i>
    </div>
  </div>
  <div
    info-first-line
    detectTextTruncation
    (truncatedChange)="handleTruncatedChange($event)"
    >
    {{ folder.name }}
  </div>
  <div info-second-line></div>
  <div info-third-line><span translate="course-table-last_modified"></span>: {{ folder.updated_at | formatDate }}</div>
  <div info-third-line-action-btns>
    @if (folder.stats?.num_unviewed_comments) {
      <comment-indicator
        [unviewedComments]="folder.stats?.num_unviewed_comments">
      </comment-indicator>
    }

    @if (canOpenMenu()) {
      <button
        class="menu-btn btn-none"
        data-cy="course-menu"
        [attr.aria-label]="'session-list-item_view-folder-options' | translate : { folder: folder.name }"
        (keyup.enter)="$event.stopPropagation();"
        (click)="openMenu($event)">
        <i class="ficon-app-dots-vertical"></i>
      </button>
    }

    <menu #menu>
      <folder-menu [folder]="selectedFolder"></folder-menu>
    </menu>
  </div>
</card-container>

